import $ from 'jQuery';


/**
 * Initializes accordion functionality for the accordion block.
 *
 * This function sets up the accordion interface by binding click events to:
 * - Individual accordion item toggles: Toggling the display of each accordion panel,
 *   updating the "aria-expanded" attribute, and handling slide animations for showing and hiding content.
 * - A general control toggle: Allowing all accordion items to be opened or closed simultaneously,
 *   updating the control's label and "aria-expanded" state.
 *
 * The implementation is based on the WAI-ARIA Authoring Practices, ensuring accessible
 * interaction with the accordion elements. As individual items are toggled, the script
 * updates the state of the general toggle based on whether all (or none) of the accordion
 * items are expanded.
 *
 * @function
 * @returns {void}
 */
export default function() {

  /*
    This implementation is based on the WAI-ARIA Authoring Practices 1.1 example:
    https://www.w3.org/TR/wai-aria-practices/examples/accordion/accordion.html

    Home/End, Up/Down keyboard binds are not handled here, and are non-essential,
    but if your project reliably renders accordion items in one column, stacked order,
    it is nice to add that functionality.

    However, as accordions are often rendered in columns, the current best-practice
    pattern for allowing two columns of accordions to function in a masonry-style layout
    (where opening an accordion in Column-A does not also push down the entire row in
    Column-B) confuses the natural DOM order of items that Home/End/Up/Down reliably
    would need to bind to. In short, assuming Home/End/Up/Down binds for all projects
    can reasonably cause more headaches that its worth, and the natural tab order and
    selection capabilities of AT are sufficient/better at navigating a broader set of
    layout options.

    - JE
  */

  const $accordionItems = $('.accordion-item');
  const $accordionItemToggles = $('.accordion-item__toggle', $accordionItems);
	const $accordionGeneralToggle = $('.accordion--control');

  if ($accordionItemToggles.length) {

    // Bind mouse click / keyboard space/enter button activation.
    // ---
    $accordionItemToggles.off('click').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const $thisToggle = $(this);

      if ($thisToggle.attr('aria-expanded') === 'true') {
        closeAccordionItem($thisToggle);
      }
      else {
        openAccordionItem($thisToggle);
      }

			// This section controls the general accordion toggle based on the state of individual items.
			// ---
			if ($accordionItemToggles.filter('[aria-expanded="true"]').length === $accordionItemToggles.length) {
				$(this).parents('.accordion').find('.accordion--control')
					.attr('aria-expanded', 'true')
						.find('label').html('Close All');
			}
			else {
				if ($accordionItemToggles.filter('[aria-expanded="true"]').length > 0) {
					$(this).parents('.accordion').find('.accordion--control')
						.attr('aria-expanded', 'false')
							.find('label').html('Expand All');
				}
			}
    });

		// This section binds a click event to the general accordion control toggle.
		// ---
		$('.accordion .accordion--control').off('click').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			const $thisToggle = $(this);

			if ($thisToggle.attr('aria-expanded') === 'true') {
				$thisToggle.parents('.accordion').find('.accordion-item__toggle').each(function() {
					closeAccordionItem($(this));
				});
				$thisToggle
					.attr('aria-expanded', 'false')
						.find('label').html('Expand All');
			}
			else {
				$thisToggle.parents('.accordion').find('.accordion-item__toggle').each(function() {
					openAccordionItem($(this));
				});
				$thisToggle
					.attr('aria-expanded', 'true')
						.find('label').html('Close All');
			}
		});
  }


  // Work functions invoked by event binds.
  // ---


  function closeAccordionItem($accordionItemToggle) {
    const $parentItem = $accordionItemToggle.closest('.accordion-item');
    const $itemPanel = $parentItem.find('.accordion-item__panel').first();

    $parentItem.removeClass('accordion-item--open');
    $accordionItemToggle.attr('aria-expanded', 'false');

    /*
      Use jquery slide collapse to hide, this is still the most
      reliable slide/expand option we have readily available.
      Also, it handles inline display: none/block at the end of its
      animation. - JE
    */
    $itemPanel.slideUp(250); // inline display: none; after 250ms.
    $itemPanel.prop('hidden', true);
  }


  function openAccordionItem($accordionItemToggle) {
    const $parentItem = $accordionItemToggle.closest('.accordion-item');
    const $itemPanel = $parentItem.find('.accordion-item__panel').first();

    $parentItem.addClass('accordion-item--open');
    $accordionItemToggle.attr('aria-expanded', 'true');

    $itemPanel.prop('hidden', false);
    $itemPanel.slideDown(250); // inline display: block; after 250ms.
  }

}
